import styled from 'styled-components';

import { IoClose } from 'react-icons/io5';
import { FiPlus } from 'react-icons/fi';
import {
  blueGray,
  primaryColor,
  primaryColorDark,
  primaryColorLight,
  primaryColorWeak,
  subMenuDropdownBackground,
} from '../../../../config/colors';
import Button from '../../../Button';
import common from '../../../../styles/common';

export const Wrapper = styled.div`
  min-width: 70rem;
  min-height: 27rem;
  position: relative;
  padding: 1.5rem;
  background-color: ${subMenuDropdownBackground};
`;

export const ModalTitle = styled.p`
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 2rem;
`;

export const CloseButton = styled(Button).attrs({
  wrapperStyle: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: '1.75rem',
    height: '1.75rem',
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'rgba(0,0,0,0.7)',
    size: '1.75rem',
  },
})``;

const ContentWrapper = styled.div`
  display: grid;
`;

export const ContentWrapperHorizontal = styled(ContentWrapper)`
  grid-template-columns: 50% 50%;
  grid-column-gap: 10px;
`;

export const ContentWrapperVertical = styled(ContentWrapper)`
  grid-template-rows: 40vh 40vh;
  grid-row-gap: 40px;
`;

export const Lane = styled.div`
  border-radius: 8px;
  box-shadow: 0px 1px 15px rgb(0 0 0 / 20%);
  padding: 10px;
  position: relative;
`;

export const Scrollable = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const LaneTitle = styled.label`
  border-radius: 8px;
  box-shadow: 0px 1px 15px rgb(0 0 0 / 20%);
  position: absolute;
  top: -12px;
  left: 24px;
  background-color: ${subMenuDropdownBackground};
  opacity: 0.9;
  padding: 4px 20px;
  z-index: 9999;

  & .highlighted-label {
    font-weight: 700;
  }
`;

export const IdCardNameWrapper = styled.h3`
  margin: 0px;
  padding: 0px;

  font-size: 0.9rem;
  font-weight: 500;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;

  & label.text {
    display: inline-flex;
    height: 32px;
    align-items: center;
    border-radius: 8px;
    box-shadow: 0px 1px 15px rgb(0 0 0 / 20%);
    color: ${primaryColor};
    padding: 0px 1rem;
  }

  & label.text .highlighted-label {
    font-weight: 700;
    color: ${primaryColorDark};
    padding-right: 4px;
  }
`;
